export const isColorDark = (color: string) => {
  const matches = color.substring(1).match(/\w\w/g)
  if (!matches) {
    return false
  }
  const [r, g, b] = matches.map((c) => parseInt(c, 16))
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b
  return luminance < 128
}
